
let reviews;
let sliders=null;

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
	  if (entry.isIntersecting) {
		entry.target.classList.add('animate');
		return;
	  }
	  if(entry.target.hasAttribute("animation-remove"))
		  entry.target.classList.remove('animate');
	});
  });

function load()
{
	reviews=document.querySelector(".reviews_list");
	sliders=document.querySelectorAll(".reviews_list > .review_item");

	document.querySelectorAll(".mvp_link").forEach(el=>{
		el.addEventListener("click",e=>{
			e.preventDefault();
			const prev_link=document.querySelector(".mvp_link.selected");
			if(prev_link)
			{
				prev_link.classList.remove("selected");
				const mvp=document.getElementById(prev_link.getAttribute("href"));
				if(mvp)
					mvp.classList.remove("selected");
			}
			el.classList.add("selected");
			document.getElementById(el.getAttribute("href")).classList.add("selected");
		})
	})

	document.querySelectorAll(".map_link").forEach(el=>{
		el.addEventListener("click",e=>{
			e.preventDefault();
			const prev=document.querySelector(".map_link.selected")
			if(prev)
			{
				prev.classList.remove("selected");
				const map=document.getElementById(prev.getAttribute("href"));
				if(map)
					map.classList.remove("selected");
			}
			el.classList.add("selected");
			document.getElementById(el.getAttribute("href")).classList.add("selected");
		});
	});

	document.querySelectorAll(".nav_menu a").forEach(el=>{
		el.addEventListener("click",e=>{
			document.getElementById("side-menu").checked=false;
		});
	})

	document.querySelectorAll('.animation').forEach(el=>{
		observer.observe(el);
	});
}

function change_map(e)
{
	const map=document.querySelector(".map_img.selected");
	if(map)
		map.classList.remove("selected");
	document.getElementById(e.target.value).classList.add("selected");
}

function change_mvp(e)
{
	const mvp=document.querySelector(".mvp.selected");
	if(mvp)
		mvp.classList.remove("selected");
	document.getElementById(e.target.value).classList.add("selected");
}

function change_review(el,e,direction)
{
	e.preventDefault();
	let item=parseInt(reviews.getAttribute("item"));
	item+=direction;
	if(item==sliders.length+1) item=1;
	if(item==0) item=sliders.length;
	reviews.setAttribute("item",item);

	const reviewWidth = reviews.querySelector('.review_item').clientWidth;
	reviews.scrollTo({
	  left: (item-1) * reviewWidth,
	  behavior: 'smooth' // Desplazamiento suave
	});
}
document.addEventListener("DOMContentLoaded", load, false);

